import requestEntityTabTemplate from '@/requests/layout/requestEntityTabTemplate';

export default requestEntityTabTemplate(['cohorts'], ({ requests }) => requests.create);
